import React, { useCallback } from 'react';
import { X, CheckCircle, Briefcase } from 'lucide-react';

const HiredNotificationModal = ({ 
  isOpen, 
  onClose, 
  onViewApplications,
  jobTitle = 'Position', 
  companyName = 'Company', 
  applicationId 
}) => {
  // Always call hooks at the top level
  const handleViewApplications = useCallback(() => {
    if (typeof onClose === 'function') {
      onClose();
    }
    if (typeof onViewApplications === 'function') {
      onViewApplications();
    }
  }, [onClose, onViewApplications]);

  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') {
      onClose();
    }
  }, [onClose]);

  // Early return after hooks
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full mx-4 overflow-hidden shadow-xl transform transition-all">
        {/* Header with close button */}
        <div className="relative bg-gradient-to-r from-green-500 to-emerald-600 px-6 py-4">
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-white hover:text-gray-200 transition-colors"
          >
            <X size={20} />
          </button>
          
          {/* Success Icon */}
          <div className="flex justify-center mb-2">
            <div className="bg-white rounded-full p-3">
              <CheckCircle className="text-green-500" size={32} />
            </div>
          </div>
          
          {/* Title */}
          <h2 className="text-center text-white text-2xl font-bold">
            Congratulations!
          </h2>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="text-center mb-6">
            <div className="flex justify-center mb-3">
              <Briefcase className="text-gray-600" size={24} />
            </div>
            <p className="text-gray-700 text-lg mb-2">
              You've been hired for the position:
            </p>
            <h3 className="font-semibold text-xl text-gray-900 mb-1">
              {jobTitle}
            </h3>
            {companyName && (
              <p className="text-gray-600">
                at {companyName}
              </p>
            )}
          </div>

          <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
            <p className="text-green-800 text-sm text-center">
              🎉 Your application has been accepted! Check your applications page for next steps and contact information.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3">
            <button
              onClick={handleClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Close
            </button>
            <button
              onClick={handleViewApplications}
              className="flex-2 px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
            >
              View Applications
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HiredNotificationModal;